import { B64File } from 'common/classes/B64File.class';
import { Membre } from 'membre/classes/Membre.class';
import { v4 } from 'uuid';
/**
 * *Super classe*
 *
 * Sert à définir et normaliser une interface entre
 * les messages de groupe et les messages personnels
 */
export class Message {
    /**
     * Constructeur du Message
     */
    constructor(row) {
        var _a;
        this.uid = v4();
        if (row) {
            const { idMessage, emetteur, recepteur, texte, dateEnvoi, images, inGroup } = row;
            this.idMessage = (_a = Number(idMessage)) !== null && _a !== void 0 ? _a : null;
            this.emetteur = new Membre(emetteur === null || emetteur === void 0 ? void 0 : emetteur.infoPublic);
            this.recepteur = recepteur;
            this.texte = texte;
            this.dateEnvoi = dateEnvoi;
            this.inGroup = inGroup;
            this.images = [];
            if (images) {
                for (const image of images) {
                    if (image instanceof B64File) {
                        this.images.push(image);
                    }
                    else {
                        this.images.push(B64File.pathUrlToFile(image.url));
                    }
                }
            }
        }
    }
    /**
     * Méthode de renvoi de l'objet en back sous la forme d'un tableau
     * @return array
     */
    toRaw() {
        return {
            idMessage: this.idMessage,
            emetteur: this.emetteur.infoPublic.idMembre,
            recepteur: this.recepteur,
            texte: this.texte,
            images: this.images.map((image) => (image instanceof B64File ? image.toRaw() : image)),
            dateEnvoi: this.dateEnvoi,
            inGroup: this.inGroup,
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVzc2FnZS5jbGFzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIk1lc3NhZ2UuY2xhc3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLDhCQUE4QixDQUFDO0FBQ3ZELE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSw2QkFBNkIsQ0FBQztBQUNyRCxPQUFPLEVBQUUsRUFBRSxFQUFFLE1BQU0sTUFBTSxDQUFDO0FBRTFCOzs7OztHQUtHO0FBQ0gsTUFBTSxPQUFPLE9BQU87SUF1Q25COztPQUVHO0lBQ0gsWUFBbUIsR0FBc0I7O1FBekNsQyxRQUFHLEdBQVcsRUFBRSxFQUFFLENBQUM7UUEwQ3pCLElBQUksR0FBRyxFQUFFO1lBQ1IsTUFBTSxFQUFFLFNBQVMsRUFBRSxRQUFRLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxHQUFHLEdBQUcsQ0FBQztZQUNsRixJQUFJLENBQUMsU0FBUyxHQUFHLE1BQUEsTUFBTSxDQUFDLFNBQVMsQ0FBQyxtQ0FBSSxJQUFJLENBQUM7WUFDM0MsSUFBSSxDQUFDLFFBQVEsR0FBRyxJQUFJLE1BQU0sQ0FBQyxRQUFRLGFBQVIsUUFBUSx1QkFBUixRQUFRLENBQUUsVUFBVSxDQUFDLENBQUM7WUFDakQsSUFBSSxDQUFDLFNBQVMsR0FBRyxTQUFTLENBQUM7WUFDM0IsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUM7WUFDbkIsSUFBSSxDQUFDLFNBQVMsR0FBRyxTQUFTLENBQUM7WUFDM0IsSUFBSSxDQUFDLE9BQU8sR0FBRyxPQUFPLENBQUM7WUFDdkIsSUFBSSxDQUFDLE1BQU0sR0FBRyxFQUFFLENBQUM7WUFDakIsSUFBSSxNQUFNLEVBQUU7Z0JBQ1gsS0FBSyxNQUFNLEtBQUssSUFBSSxNQUFNLEVBQUU7b0JBQzNCLElBQUksS0FBSyxZQUFZLE9BQU8sRUFBRTt3QkFDN0IsSUFBSSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUM7cUJBQ3hCO3lCQUFNO3dCQUNOLElBQUksQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxhQUFhLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUM7cUJBQ25EO2lCQUNEO2FBQ0Q7U0FDRDtJQUNGLENBQUM7SUFFRDs7O09BR0c7SUFDSSxLQUFLO1FBQ1gsT0FBTztZQUNOLFNBQVMsRUFBRSxJQUFJLENBQUMsU0FBUztZQUN6QixRQUFRLEVBQUUsSUFBSSxDQUFDLFFBQVEsQ0FBQyxVQUFVLENBQUMsUUFBUTtZQUMzQyxTQUFTLEVBQUUsSUFBSSxDQUFDLFNBQVM7WUFDekIsS0FBSyxFQUFFLElBQUksQ0FBQyxLQUFLO1lBQ2pCLE1BQU0sRUFBRSxJQUFJLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFDLEtBQUssRUFBRSxFQUFFLENBQUMsQ0FBQyxLQUFLLFlBQVksT0FBTyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsS0FBSyxFQUFFLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFDO1lBQ3RGLFNBQVMsRUFBRSxJQUFJLENBQUMsU0FBUztZQUN6QixPQUFPLEVBQUUsSUFBSSxDQUFDLE9BQU87U0FDckIsQ0FBQztJQUNILENBQUM7Q0FDRCJ9